import React from 'react';

// bootstrap
import { Form, ListGroup } from 'react-bootstrap'

// styling
import { Colors } from '_styles';

const AnswerOptions = (props) => {
    return (
        <div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>
                    Answer Options ({props.language.toUpperCase()})
                </Form.Label>
            </div>

            {props.options.map((option, index) => (
                <ListGroup.Item key={index} className="d-flex" style={{ direction: props.language === "ar" ? "rtl" : "ltr" }}>
                    <Form.Control type="text" readOnly={props?.readOnly} value={option} className="me-2" />
                </ListGroup.Item>
            ))}
        </div>
    );
};

export default AnswerOptions;